import {CompetitorPlayersStatsModuleState} from "../models/competitor-players-stats-module.state";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {COMPETITOR_PLAYER_STATS} from "../competitor-players-stats-module.consts";
import type {CompetitorPlayersStatsModuleController} from "../competitor-players-stats-module.controller";

export class CompetitorPlayersStatsModulePlayerChangeHandler extends ActionHandler {
  state: CompetitorPlayersStatsModuleState;
  controller: CompetitorPlayersStatsModuleController;
  type = COMPETITOR_PLAYER_STATS.ACTION_TYPES.onPlayerChange;

  static injectables = [...ActionHandler.injectables];

  async action(params){
    this.state.activeTabIndex = this.state.tabs?.first()?.index;

    const isVisible = this.state.isShallowShotMap;
    this.state.selectedAthleteId = this.state.players.find(player => player.athleteId === params.athleteId).athleteId;
    this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onGoalViewExpanded, {isVisible: isVisible})
    this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.statsDisplayHandler, params)
    this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.statsPlayerScrollHandler, params)

    if(this.controller.props?.matchWeekKey) {
      this.state.matchWeekAthleteId = this.state.selectedAthleteId;
      this.state.matchWeekGameId = this.state.game.id;
      this.controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.athleteLineupFetch, params)
    }
  }
}
